type FormatArgs = {
  schoolDataType?: string;
  serviceProviderIds?: string[];
  programmeIds?: string[];
  interventionIds?: string[];
  schoolIds?: string[];
  data: any[];
};

export const formatSchoolExportData = ({ schoolDataType, data, interventionIds, schoolIds }: FormatArgs) => {
  let results: any[] = [];
  const fieldMap = {
    'NSC Progression Data': 'nscProgressionData',
    'NSC Subject Data': 'nscSubjectData',
    'Learner Attendance Data': 'schoolAttendanceData',
    'Educator Attendance Data': 'schoolEducator',
    'School Enrolment Data': 'schoolEnrolmentData',
    'School Promotion Data': 'schoolPromotionData',
    'Report Results Data': 'schoolSubjectReportData',
    'Exam/Test Performance Data': 'testPerformanceData',
  };
  const schoolDataSet = new Set();

  data.forEach(intervention => {
    const { id, name, focusSubjects, grades, programme, serviceProviders, subject } = intervention;
    const focusSubjectsNames = focusSubjects && focusSubjects.map((focus: any) => focus.name);
    const gradeValues = !!grades && grades.forEach((grade: any) => grade.value);

    !!schoolDataType &&
      intervention[fieldMap[schoolDataType]].forEach((schoolData: any) => {
        if ((schoolIds && schoolIds.length) || (interventionIds && interventionIds.length)) {
          results.push({
            interventionId: id,
            interventionName: name,
            interventionProgramme: programme && programme.name,
            interventionServiceProvider: serviceProviders.length && serviceProviders[0].name,
            interventionSubject: subject && subject.name,
            interventionFocusSubjects:
              focusSubjectsNames && focusSubjectsNames.length ? focusSubjectsNames.join(',') : '',
            interventionGrades: gradeValues && gradeValues.length ? gradeValues.join(',') : '',
            ...schoolData,
          });
        } else {
          if (!schoolDataSet.has(schoolData.id)) {
            schoolDataSet.add(schoolData.id);

            results.push({
              interventionId: id,
              interventionName: name,
              interventionProgramme: programme && programme.name,
              interventionServiceProvider: serviceProviders.length && serviceProviders[0].name,
              interventionSubject: subject && subject.name,
              interventionFocusSubjects:
                focusSubjectsNames && focusSubjectsNames.length ? focusSubjectsNames.join(',') : '',
              interventionGrades: gradeValues && gradeValues.length ? gradeValues.join(',') : '',
              ...schoolData,
            });
          }
        }
      });
  });

  return results;
};
